import axios from "axios";

// Use environment variable for API base URL
const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/";

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to automatically attach JWT token from localStorage
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// API functions
export const registerUser = async (data) => {
  return await axiosInstance.post("register/", data);
};

export const loginUser = async (data) => {
  return await axiosInstance.post("login/", data);
};

// Optional helper if you want to manually set/clear token
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("access_token", token);
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("access_token");
    delete axiosInstance.defaults.headers.common["Authorization"];
  }
};

export default axiosInstance;